const Data = [
    {
        name: "Jitendra Kumar",
        position: "TechOps Head",
        imageUrl: "/assets/images/members/Heads23/Jitendra Kumar.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100075395236728",
        linkedinLink: "https://www.linkedin.com/in/jitendra-bunkar-547223232/",
        email: "jitendra.bunkar@gyws.org"
    },
    {
        name: "Ujjawal Kumar",
        position: "TechOps Head",
        imageUrl: "/assets/images/members/Heads23/UjjawalKumar.png",
        facebookLink: "https://www.facebook.com/profile.php?id=100012980770787",
        linkedinLink: "https://www.linkedin.com/in/ujjawal-kumar-45a431228/",
        email: "ujjawal.kumar@gyws.org"
    },
]

export default Data;